import { FC } from "react";
import { Spin } from "antd";
import {
  AiRunTracker,
  AiState,
  getDisplayedAiState,
  hasActiveAiRun,
  isAiActiveState,
  terminalAiMessage,
} from "./aiStatus";

type AiStatusIndicatorProps = {
  tracker?: AiRunTracker;
  state?: AiState | null | undefined;
};

const AiStatusIndicator: FC<AiStatusIndicatorProps> = ({ tracker, state }) => {
  const displayedState = tracker ? getDisplayedAiState(tracker) : state;
  const isActive = tracker
    ? hasActiveAiRun(tracker)
    : isAiActiveState(displayedState);

  if (isActive) {
    return (
      <div
        className="chat-ai-status"
        role="status"
        aria-live="polite"
        data-testid="bizai-thinking"
      >
        <Spin size="small" aria-label="ビズAIが回答を作成中" />
        <span>ビズAIが回答を作成中です…</span>
      </div>
    );
  }

  const terminalMessage = terminalAiMessage(displayedState);
  if (!terminalMessage) return null;

  return (
    <div
      className="chat-ai-status chat-ai-status--terminal"
      role="status"
      aria-live="polite"
    >
      <span>{terminalMessage}</span>
    </div>
  );
};

export type { AiStatusIndicatorProps };
export default AiStatusIndicator;
